module.exports = __webpack_public_path__ + "img/logo_gaussy.8b40cd0.svg";